import { useState } from "react";

const { MenuItem, Select } = require("@material-ui/core");
const { FormControl } = require("react-bootstrap");
const { default: ReactPaginate } = require("react-paginate");

const ManagePaginate = (props) => {
  let { handlePageClick, totalRecords, handleRowsPerPageChange, currentPage } = props;
  const [rowsPerPage, setRowsPerPage] = useState(10);
  if (!currentPage) {
    currentPage = 1;
  }
  const OnHandleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    handleRowsPerPageChange(currentPage, parseInt(e.target.value, 10))
  };
  // if (totalRecords <= rowsPerPage) {
  //   return <></>
  // }
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div style={{ marginLeft: "50px" }}>
        {/* Dropdown to select rows per page */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ marginLeft: "10px", marginRight: "10px" }}>Rows per page</span>
          <Select
            labelId="rows-per-page-label"
            value={rowsPerPage}
            onChange={OnHandleRowsPerPageChange}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={30}>30</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={1000}>1000</MenuItem>
          </Select>
        </div>
      </div>
      <p style={{fontFamily: "Gt-Walsheim-medium"}}>Total Records:{` ${props.records}`}</p>
      {/* ReactPaginate component */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ReactPaginate
        btn
          previousLabel={"Previous"}
          nextLabel={"Next"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={totalRecords}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          pageLinkClassName={"react_paginate_pointer"}
        />
      </div>
    </div>
  )
}

export default ManagePaginate